import { Injectable } from '@angular/core';
import { ToastComponent } from '@app/components/toast/toast.component';
import { ToastrService } from 'ngx-toastr';

interface ToastDetail {
  title?: string;
  message: string;
  payload?: any;
}

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  constructor(private toastr: ToastrService) {}
  // disableTimeOut: true,
  info({ title = 'Info', message }: ToastDetail) {
    this.toastr.info(message, title, {
      tapToDismiss: false,
      toastComponent: ToastComponent,
      timeOut: 3000,
      closeButton: false,
    });
  }

  success({ title = 'Success', message }: ToastDetail) {
    this.toastr.success(message, title, {
      tapToDismiss: false,
      toastComponent: ToastComponent,
      timeOut: 3000,
      closeButton: false,
    });
  }

  warning({ title = 'Warning', message }: ToastDetail) {
    this.toastr.warning(message, title, {
      tapToDismiss: false,
      toastComponent: ToastComponent,
      timeOut: 3000,
      closeButton: false,
    });
  }

  error({ title, message, payload }: ToastDetail) {
    this.toastr.error(message, title || 'Error', {
      tapToDismiss: false,
      toastComponent: ToastComponent,
      timeOut: 3000,
      closeButton: false,
      payload,
    });
  }
}
